import React, { useState, useMemo } from "react";
import ReactDropdown from "react-dropdown";
import DateTimePicker from "components/GenericComponent/DateTimePicker";

const kieuVayMap = {
    "0": "Tất cả", "1": "Cầm đồ", "2": "Tín chấp", "3": "Trả góp"
};
const tinhTrangGiaHanOptionsMap = {
    "0": "Tất cả", "1": "Không gia hạn", "2": "Gia hạn"
};

const CommonFilters = ({ dataSearch, handleInputChange, handleDropdownChange, handleDateChange, kieuVayOptions }) => (
    <>
        <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
            <label className="font-color-default font-bold">Tên, sđt khách hàng</label>
            <input type="text" name="name" value={dataSearch.name} onChange={handleInputChange} className="form-control input-sm" placeholder="Nhập tên, SĐT" />
        </div>
        <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
            <label className="font-color-default font-bold">Đến ngày</label>
            <DateTimePicker
                value={dataSearch.dateTo}
                onChange={handleDateChange}
                placeholder="Chọn ngày"
            />
        </div>
        <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
            <label className="font-color-default font-bold">Kiểu vay</label>
            <ReactDropdown
                options={kieuVayOptions}
                onChange={(option) => handleDropdownChange('type', option)}
                value={kieuVayOptions.find(opt => opt.value === dataSearch.type)}
                controlClassName="form-control input-sm"
            />
        </div>
    </>
);

export const SearchBarHopDong = ({ dataSearch, setDataSearch, onSearch, nguoiTaoOptions, tinhTrangOptions }) => {
    const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState(false);
    const kieuVayOptions = useMemo(() => Object.entries(kieuVayMap).map(([value, label]) => ({ value, label })), []);
    const tinhTrangGiaHanOptions = useMemo(() => Object.entries(tinhTrangGiaHanOptionsMap).map(([value, label]) => ({ value, label })), []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDataSearch(prev => ({ ...prev, [name]: value }));
    };

    const handleDropdownChange = (name, option) => {
        setDataSearch(prev => ({ ...prev, [name]: option.value }));
    };

    const handleDateChange = (date) => {
        setDataSearch(prev => ({ ...prev, dateTo: date }));
    };

    const handleSearch = () => {
        const newSearchData = { ...dataSearch, pageIndex: 1 };
        onSearch(newSearchData);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };
    return (
        <div className="card border-light mb-1 card-v2" onKeyDown={handleKeyDown}>
            <div className="card-body card-body-v2" style={{ padding: '12px 16px 8px 16px' }}>
                {!isAdvancedSearchOpen ? (
                    <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3 flex-wrap">
                        <CommonFilters
                            dataSearch={dataSearch}
                            handleInputChange={handleInputChange}
                            handleDropdownChange={handleDropdownChange}
                            handleDateChange={handleDateChange}
                            kieuVayOptions={kieuVayOptions}
                        />
                        <div className="input-sm-new">
                            <button type="button" className="btn btn-info-new" style={{ paddingTop: "7px" }} onClick={handleSearch}>
                                <i className="la la-search"></i><span> &nbsp; TÌM KIẾM</span>
                            </button>
                        </div>
                        <div className="input-sm-new">
                            <button type="button" className="btn btn-info-new" style={{ paddingTop: "7px" }} onClick={(e) => { e.preventDefault(); setIsAdvancedSearchOpen(true); }}>
                                <span> &nbsp; Nâng cao</span>
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="d-flex justify-content-between align-items-center mt-1">
                            <h2 className="dang-vay">Tìm kiếm nâng cao</h2>
                        </div>
                        <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3 flex-wrap">
                            <CommonFilters
                                dataSearch={dataSearch}
                                handleInputChange={handleInputChange}
                                handleDropdownChange={handleDropdownChange}
                                handleDateChange={handleDateChange}
                                kieuVayOptions={kieuVayOptions}
                            />
                            <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
                                <label className="font-color-default font-bold">Tình trạng</label>
                                <ReactDropdown
                                    options={tinhTrangOptions}
                                    onChange={(option) => handleDropdownChange('debtLevel', option)}
                                    value={tinhTrangOptions.find(opt => opt.value === dataSearch.debtLevel)}
                                    controlClassName="form-control input-sm"
                                />
                            </div>
                            <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
                                <label className="font-color-default font-bold">Mã tài sản</label>
                                <input type="text" name="code" value={dataSearch.code} onChange={handleInputChange} className="form-control input-sm" />
                            </div>
                            <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
                                <label className="font-color-default font-bold">Tình trạng gia hạn</label>
                                <ReactDropdown
                                    options={tinhTrangGiaHanOptions}
                                    onChange={(option) => handleDropdownChange('statusGiaHan', option)}
                                    value={tinhTrangGiaHanOptions.find(opt => opt.value === dataSearch.statusGiaHan)}
                                    controlClassName="form-control input-sm"
                                />
                            </div>
                            <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
                                <label className="font-color-default font-bold">Người tạo hợp đồng</label>
                                <ReactDropdown
                                    options={nguoiTaoOptions}
                                    onChange={(option) => handleDropdownChange('user', option)}
                                    value={nguoiTaoOptions.find(opt => opt.value === dataSearch.user)}
                                    controlClassName="form-control input-sm"
                                />
                            </div>
                            <div className="input-sm-new" style={{ flex: 1, minWidth: '180px' }}>
                                <label className="font-color-default font-bold">Địa chỉ</label>
                                <input type="text" name="address" value={dataSearch.address} onChange={handleInputChange} className="form-control input-sm" />
                            </div>
                        </div>
                        <div className="d-flex justify-content-end mt-2">
                            <button type="button" className="btn btn-info-new" style={{ marginRight: 15 }} onClick={handleSearch}>
                                <i className="la la-search"></i><span> &nbsp; TÌM KIẾM</span>
                            </button>
                            <button type="button" className="btn btn-info-new" style={{ marginRight: 15 }} onClick={() => setIsAdvancedSearchOpen(false)}>
                                <span>Thu gọn</span>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};